module.exports = __webpack_public_path__ + "nick-814feebd8550616045b888d9662288ad.webp";